<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 37 28"
  *ngIf="name === 'check'"
>
  <path
    d="M36.5969 4.22286C36.5969 5.30061 36.1723 6.33466 35.4238 7.092L16.7626 25.9818C15.1937 27.5693 12.6532 27.5693 11.0843 25.9818L1.78605 16.5733C0.21715 14.9858 0.21715 12.4152 1.78605 10.8277C3.35495 9.24022 5.89542 9.24022 7.46432 10.8277L13.927 17.3598L29.7456 1.35371C31.3145 -0.233788 33.8549 -0.233788 35.4238 1.35371C36.1723 2.11833 36.5969 3.15239 36.5969 4.22286Z"
  />
</svg>

<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 24 24"
  *ngIf="name === 'close'"
>
  <path
    d="M18 6L6 18M6 6l12 12"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 24 24"
  *ngIf="name === 'menu'"
>
  <path d="M4 6h16M4 12h16m-16 6h16" />
</svg>

<!-- icona back -->
<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 11 20"
  *ngIf="name === 'back'"
>
  <path
    d="M9.53769 0.999818L1 9.53751L9.53769 18.0752"
    stroke="#333333"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<!-- icona custom dropdown select element -->
<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 19 12"
  *ngIf="name === 'dropdown'"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.98574 10.2803C9.26976 10.5732 9.73024 10.5732 10.0143 10.2803L17.287 2.78033C17.571 2.48744 17.571 2.01256 17.287 1.71967C17.003 1.42678 16.5425 1.42678 16.2585 1.71967L9.5 8.68934L2.74153 1.71967C2.45751 1.42678 1.99703 1.42678 1.71301 1.71967C1.429 2.01256 1.429 2.48744 1.71301 2.78033L8.98574 10.2803Z"
    fill="black"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<!-- iconda dubbi o domande -->
<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="img"
  viewBox="0 0 29 17"
  *ngIf="name === 'help'"
>
  <path
    d="M8.3793 1.28906C5.76077 1.28906 3.3914 2.53902 1.95756 4.62228C0.585607 6.64646 0.273763 9.14637 1.2093 11.3486L0.0246093 15.2174C-0.0380811 15.3961 0.0246089 15.634 0.149186 15.8128C0.273763 15.9916 0.522917 16.0507 0.710184 15.9916L4.70067 15.2181C5.88535 15.8136 7.13192 16.1113 8.3793 16.1113C9.68857 16.1113 10.9978 15.7545 12.2452 15.0992C14.6765 13.7894 16.1111 11.3493 16.1111 8.72971C16.1111 4.5632 12.6197 1.28906 8.38011 1.28906H8.3793ZM11.8707 12.0031H5.19897C4.82524 12.0031 4.57528 11.7054 4.57528 11.4076C4.57528 11.1099 4.82444 10.8122 5.19897 10.8122H11.8707C12.2444 10.8122 12.4944 11.1099 12.4944 11.4076C12.4944 11.7644 12.1825 12.0031 11.8707 12.0031ZM11.8707 9.2653H5.19897C4.82524 9.2653 4.57528 9.02743 4.57528 8.66986C4.57528 8.3123 4.82444 8.07443 5.19897 8.07443H11.8707C12.2444 8.07443 12.4944 8.3123 12.4944 8.66986C12.4944 9.02743 12.1825 9.2653 11.8707 9.2653ZM11.8707 6.46767H5.19897C4.82524 6.46767 4.57528 6.16995 4.57528 5.87223C4.57528 5.51543 4.82444 5.2768 5.19897 5.2768H11.8707C12.2444 5.2768 12.4944 5.51467 12.4944 5.87223C12.4944 6.16995 12.1825 6.46767 11.8707 6.46767Z"
    fill="#F7257D"
  />
  <path
    d="M28.9762 14.0265L27.7915 10.1307C28.7271 7.8528 28.4152 5.33539 27.0432 3.29705C25.6093 1.2587 23.1772 0 20.5586 0C18.3137 0 16.2561 0.958902 14.8223 2.45791C16.4434 4.01642 17.4409 6.17452 17.4409 8.5119C17.4409 10.2504 16.8799 11.9287 15.9443 13.3072C18.3137 15.0457 21.6179 15.3455 24.2992 13.9068L28.2898 14.6856C28.4771 14.7459 28.7263 14.6856 28.8509 14.5056C28.9754 14.4453 29.0381 14.2058 28.9754 14.0258L28.9762 14.0265ZM21.5561 11.6289C21.5561 11.9882 21.3069 12.2285 20.9323 12.2285C20.6205 12.2285 20.3086 11.989 20.3086 11.6289C20.3086 11.2688 20.6205 11.0293 20.9323 11.0293C21.2442 11.0293 21.5561 11.2688 21.5561 11.6289ZM21.7433 8.4524C21.6187 8.57216 21.5561 8.69193 21.5561 8.87197V9.59134C21.5561 9.89114 21.3069 10.1909 20.9323 10.1909C20.6205 10.1909 20.3086 9.89114 20.3086 9.59134V8.93224C20.3086 8.27314 20.6824 7.73303 20.9942 7.55377C21.1815 7.434 22.2416 6.5346 22.2416 5.27589C22.2416 3.59762 19.623 3.59762 19.623 5.27589V5.81523C19.623 6.17452 19.3739 6.41483 18.9993 6.41483C18.6248 6.41483 18.3756 6.1753 18.3756 5.81523V5.21562C18.3756 4.25672 18.8121 3.71739 19.1858 3.35732C20.6824 2.09861 23.4883 2.81798 23.4883 5.21562C23.4883 6.8344 22.3035 8.03283 21.7425 8.4524H21.7433Z"
    fill="#F7257D"
  />
</svg>

<!-- Icona copy clipboard -->
<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="image"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 448 512"
  *ngIf="name === 'copy'"
>
  <path
    d="M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    fill="#F7257D"
  ></path>
</svg>

<!-- Icona info -->
<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="color"
  role="image"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
  *ngIf="name === 'info'"
>
  <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
</svg>